/*
 * DVS Diamonds -- shared scroll-reveal utility for the premium page system.
 * IntersectionObserver only, no other JS, no dependencies.
 *
 * Elements carrying [data-dvs-reveal] start hidden (see dvs-tokens.css) and
 * fade/lift into place the first time they cross the viewport, then are
 * unobserved (one-shot). This is the scroll-triggered counterpart to the
 * homepage's existing load-time fade pattern (dvsEditorialFadeUp) -- used
 * here instead because premium-page components sit further down the page,
 * where a load-time animation would already be finished before a visitor
 * scrolls to see it.
 *
 * Safe by construction: if IntersectionObserver is unsupported, or this
 * script fails to run at all, elements are still visible -- see the
 * IntersectionObserver-support check below and the <noscript> override
 * emitted alongside this script's <script> tag.
 */
(function () {
  var targets = document.querySelectorAll('[data-dvs-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    targets.forEach(function (el) {
      el.classList.add('dvs-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dvs-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
